@use "@fukuri-admins/ui/layout" as *;

.Root {
  &__Header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  &__Title {
    font-weight: 600;
    margin-bottom: 8px;
    font-size: 28px;
  }
  &__Description {
    font-size: 14px;
    color: $TextLabel;
    text-align: center;
  }
  .menuContainer {
    display: flex;
    justify-content: center;
    align-items: center;
    .outputCsv {
      cursor: pointer;
      padding: 8px 16px;
      border-radius: 6px;
      background-color: $Button;
      color: $White;
      svg {
        color: currentColor;
      }
      display: flex;
      align-items: center;
      font-weight: 600;
      gap: 4px;
      font-size: 12px;
      transition: background-color 0.2s ease-out;
      &:hover {
        background-color: $ButtonHover;
      }
    }
  }
  .loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
